import React from "react";
import ChartReport from "./Report";

const InstallationPartnerChart = ({ lastMonthData }) => {
  return (
    <>
      <ChartReport
        lastMonthData={lastMonthData}
        title="Installers"
        dataKey="installationPartnerCount"
      />
    </>
  );
};

export default InstallationPartnerChart;
